export default __webpack_public_path__ + "static/media/call-action-three-bg.37ab01a2.jpg";